import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'realDark',
  colorPrimary: '#F59E0B',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  pwa: true,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  siderWidth: 208,
  token: { header: { heightLayoutHeader: 44 } },
  splitMenus: true,
  menu: {
    defaultOpenAll: true,
    ignoreFlatMenu: true,
    autoClose: false,
  },
};
export default Settings;
